<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 card_bg">
					<op-cd-mng-search ref="search" :scrId="scrId"></op-cd-mng-search>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<op-cd-mng-table ref="table" @Refresh="Refresh" :scrId="scrId"></op-cd-mng-table>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/OpCdMng/store/helpers';
import OpCdMngSearch from './Search/OpCdMngSearch.vue';
import OpCdMngTable from './Table/OpCdMngTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {},
			faivorite: true,
			screen: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	components: {
		OpCdMngSearch,
		OpCdMngTable
	},
	methods: {
		...serviceMethods,
		Refresh() {
			this.$sf_toggleLoading(false);
			this.$refs.search.searchList();
		}
	},
	created() {
		this.$sf_toggleLoading(true);
		this.getCommCodes_({ key: 'opCdList', codeType: 'OP_CD' }); //OP코드;
		this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' }); //사용 여부;
		this.$sf_toggleLoading(false);
	}
};
</script>

<style></style>
